import type { ConfigurationContextValue } from "./ConfigurationContext";

export const defaultDarkModeLogo = "./logos/logo_atomic_crm_dark.svg";
export const defaultLightModeLogo = "./logos/logo_atomic_crm_light.svg";

export const defaultTitle = "Dental Revenue Operator";

export const defaultCompanySectors = [
  { value: "meta-ads", label: "Meta Ads" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "website", label: "Website" },
  { value: "referral", label: "Patient Referral" },
  { value: "doctor-referral", label: "Doctor Referral" },
  { value: "walk-in", label: "Walk-in" },
];

export const defaultDealStages = [
  { value: "new-lead", label: "New Lead" },
  { value: "contacted", label: "Contacted" },
  { value: "qualified", label: "Qualified" },
  { value: "consultation-booked", label: "Consultation Booked" },
  { value: "attended", label: "Attended" },
  { value: "proposal-sent", label: "Proposal Sent" },
  { value: "accepted", label: "Accepted" },
  { value: "deposit-paid", label: "Deposit Paid" },
  { value: "lost", label: "Lost" },
];

export const defaultDealPipelineStatuses = ["deposit-paid"];

export const defaultDealCategories = [
  { value: "implant", label: "Implant" },
  { value: "full-arch", label: "Full Arch" },
  { value: "veneers", label: "Veneers" },
  { value: "aligners", label: "Aligners" },
  { value: "restorative", label: "Restorative" },
];

export const defaultNoteStatuses = [
  { value: "needs-education", label: "Needs Education", color: "#7dbde8" },
  { value: "price-shopper", label: "Price Shopper", color: "#e8cb7d" },
  { value: "warm", label: "Warm", color: "#9fd5cc" },
  { value: "hot", label: "Hot", color: "#e88b7d" },
  { value: "clinician-review", label: "Clinician Review", color: "#b8a7e8" },
];

export const defaultTaskTypes = [
  { value: "none", label: "None" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "call", label: "Call" },
  { value: "book-consultation", label: "Book Consultation" },
  { value: "send-proposal", label: "Send Proposal" },
  { value: "follow-up", label: "Follow-up" },
  { value: "collect-deposit", label: "Collect Deposit" },
  { value: "rebook", label: "Rebook" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
